import React from 'react'

const TransferSentIcon = () => (
  <svg
    width='32'
    height='33'
    viewBox='0 0 32 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='16' cy='16.5' r='15.5' stroke='#2A1846' />
    <path
      d='M16.9656 14.2662C17.499 14.7996 17.499 15.6642 16.9656 16.1976C16.4323 16.7309 15.5677 16.7309 15.0343 16.1976C14.5009 15.6642 14.5009 14.7996 15.0343 14.2662C15.5677 13.7329 16.4323 13.7329 16.9656 14.2662'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.2438 13.866V16.5977'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.756 13.866V16.5977'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.9997 23.4268V20.0122'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.9996 20.0122L14.6338 21.3781'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.3659 21.3781L16 20.0122'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.2681 19.3294H11.2194C10.4647 19.3294 9.85352 18.7182 9.85352 17.9635V12.5001C9.85352 11.7455 10.4647 11.1343 11.2194 11.1343H20.7803C21.535 11.1343 22.1462 11.7455 22.1462 12.5001V17.9635C22.1462 18.7182 21.535 19.3294 20.7803 19.3294H18.7316'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default TransferSentIcon
